/**
 * Shared lead-conversion status for conversation browse rows (BUB-135 / BUB-140 / BUB-141 / BUB-147).
 */

/**
 * @param {{ inboxStatus?: string|null }} record
 */
export function getConversationInboxStatusTag(record) {
  if (record?.inboxStatus === "closed") {
    return { key: "inbox-closed", label: "Closed", color: "default" };
  }
  return null;
}

/**
 * @param {{ assignedTo?: string|null, handoffStatus?: string|null }} record
 */
export function getConversationHandoffStatusTag(record) {
  if (record?.assignedTo) {
    return {
      key: "assigned",
      label: `Assigned: ${record.assignedTo}`,
      color: "purple",
    };
  }
  if (record?.handoffStatus === "active") {
    return { key: "handoff", label: "Handoff active", color: "geekblue" };
  }
  return null;
}

/**
 * @param {{ leadId?: string|null, draftReadyToPromote?: boolean, draftStatus?: string|null }} record
 */
export function isReadyForLeadConversion(record) {
  return Boolean(record && !record.leadId && record.draftReadyToPromote === true);
}

/**
 * Lead-link / draft readiness tag for a conversation row.
 * @param {{ leadId?: string|null, draftReadyToPromote?: boolean, draftStatus?: string|null }} record
 */
export function getConversationLeadStatusTag(record) {
  if (record?.leadId) {
    return { key: "lead", label: "Lead linked", color: "green" };
  }
  if (record?.draftReadyToPromote) {
    return { key: "ready-for-lead", label: "Ready for lead", color: "green" };
  }
  if (record?.draftStatus === "draft") {
    return { key: "draft", label: "Draft", color: "gold" };
  }
  return { key: "unlinked", label: "Not linked to a lead", color: "gold" };
}
